import Abonements from "src/pages/Abonements/Abonements";

export function base64ToArrayBuffer(base64) {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export function buildBody (reportName, params = []) {
    const body = {
        "fileExtension": "xlsx",
        "reportName": reportName,
        "paramList": [
            {
                "name":"request",
                "value": {
                    ...params,
                    'AbonementDateEnd': {
                        From: params['AbonementDateEnd.From'],
                        To: params['AbonementDateEnd.To']
                    },
                    'AbonementDateStart': {
                        From: params['AbonementDateStart.From'],
                        To: params['AbonementDateStart.To']
                    },
                    'AbonementDateEnd.From': null,
                    'AbonementDateEnd.To': null,
                    'AbonementDateStart.From': null,
                    'AbonementDateStart.To': null,
                }
            }
        ],
    }
    return body
}

export function buildAdditionaldBody (reportName, params = []) {
    const body = {
        "fileExtension": "xlsx",
        "reportName": reportName,
        "paramList": params,
    }
    return body
}

export function downloadReportXlsx (value, name = 'Report') {
    const bufferArray = base64ToArrayBuffer(value);
    const url = URL.createObjectURL(new Blob([bufferArray]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${name}.xlsx`);
    document.body.appendChild(link);
    link.click()
}
